import * as React from "react";
import { Row, Col, Button } from "rsuite";
import { numberFormatter } from "../../utils";
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export class DivisionWiseTable extends React.Component<any, any> {
  customerData: any;
  initialLoad: boolean = true;
  constructor(props: any) {
    super(props);
    this.state = {
      tableHeight: 250,
      refresh: true,
      isAcceptAll: false,
      acceptL4List: [],
      checked: false,
      checked2: false,
      peerWtAvgPrice: 0,
    };
  }
  componentDidMount() {
    this.setState({
      tableHeight: window.innerHeight - 220 - 405, // minus 140 to fit into the page size
    });
    // window.addEventListener("resize", (event) => {
    //   this.setState({
    //     tableHeight: window.innerHeight - 220 - 405, // minus 140 to fit into the page size
    //   });
    // });
  }

  dummyRefresh() {
    setTimeout(() => {
      this.setState({
        refresh: false,
      });
    }, 0);
  }

  AsyncToggle = () => {
    // this.setState({ loading: true });
    // setTimeout(() => {
    this.setState({ checked: !this.state.checked });
    // }, 1000);
  };

  AsyncToggleForExecution = () => {
    this.setState({ checked2: !this.state.checked2 });
  };

  thousands = (value: any) =>
    `${value}`.replace(/(?=(?!(\b))(\d{3})+$)/g, "$1,");
  handleAccept = (isAll: boolean = false, l4: any = "") => {
    if (isAll) {
      this.setState({
        isAcceptAll: true,
      });
    } else {
      let oldL4List = this.state.acceptL4List;
      oldL4List.push(l4);
      this.setState({
        acceptL4List: oldL4List,
      });
    }
  };

  validateNumbers = (e: any) => {
    return (e.target.value = e.target.value
      .replace(/[^\d.]/g, ''));
    // .replace(/^\d*\.?\d*$/, "$1"));
  };

  handleDecimalsOnValue(value: any) {
    const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/g;
    return value.match(regex).join('');
  }
  render() {
    const {
      scatterData,
      itemExecPrice,
      itemId,
      index,
      summaryData,
      selectedCustomerData,
      recommendationAction,
      handleAcceptFromCustomerSelect,
      handleRejectFromCustomerSelect,
      height,
      handleExecutionPriceChange,
      handleSubmit,
      handleExportPricingReport,
    } = this.props;
    const data = scatterData;
    let tableData: any = [];
    let calcWidth = (eleId: string) => {
      return document.getElementById(eleId)?.offsetWidth;
    };
    let col1Width: any;
    col1Width = calcWidth("customerGraphId");

    if (
      data &&
      JSON.stringify(this.customerData) != JSON.stringify(selectedCustomerData)
    ) {
      this.dummyRefresh();
      this.customerData = selectedCustomerData;
    }

    if (data && !this.state.refresh) {
      Object.values(data.l4AvgPrice).sort((a: any, b: any) => a.opportunity > b.opportunity ? -1 : 1).forEach((d: any, i: any) => {
        d.forEach((d1: any) => {
          if (d1.customer === selectedCustomerData?.customer) {
            d1.itemId = index ? Object.keys(data.l4AvgPrice)[i] : null;
            d1.executedPrice = index ? d1.executedPrice : data.ItemRecommPrice;
            d1.customWidth = calcWidth(d1.l4);
            d1.opportunity = d1.volume * (d1.executedPrice - d1.price);
            tableData.push(d1);
          }
        });
      });
    }

    return (
      <>
        <Row className="show-grid" style={{ height: height }}>
          <Col xs={24} sm={24} md={24}>
            {
              tableData ? (
                <>
                  <table
                    style={{ fontSize: "0.76vw", height: '13vw' }}
                    className="divTable pricingTable"
                  >
                    <thead>
                      <tr>
                        <th
                          style={{ width: "40%" }}
                          className="divTableHead pricing attr alignCenter"
                        >
                          Item
                        </th>
                        {tableData.sort((a: any, b: any) =>
                          a.opportunity > b.opportunity ? -1 : 1
                        ).map((d: any) => (
                          <th
                            style={{
                              width: index ? "15%" : "80%",
                              backgroundColor: d.l4 ? "#353535" : "black",
                              borderRight: "1px solid #666362",
                              borderLeft: "1px solid #666362",
                            }}
                            className="divTableHead pricing alignCenter"
                          >
                            Item ID - {index ? d?.itemId : itemId ? itemId : ""}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Volume</td>
                        {tableData.map((d: any) => (
                          <td className="alignCenter">
                            {
                              Number(
                                index ? d.volume : scatterData.summaryData.volume
                              ).toLocaleString()
                            }
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td>Current Price ($)</td>
                        {tableData.map((d: any) => (
                          <td className="alignCenter">
                            ${numberFormatter(Number(d.price), 2)}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td>Target Price ($)</td>
                        {tableData.map((d: any) => (
                          <td
                            className="alignCenter"
                            style={{ verticalAlign: "middle" }}
                          >
                            {scatterData.summaryData.peerPrice === null
                              ? "-"
                              : `$${parseFloat(
                                index
                                  ? d.peerPrice
                                  : scatterData.summaryData.peerPrice
                              ).toFixed(2)}`}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "center" }}>
                          Adjusted Price ($)
                        </td>
                        {tableData.map((d: any, i: any) => (
                          <td className="alignCenter">
                            $
                            <input
                              type="text"
                              key={d?.itemId}
                              onInput={(e) => this.validateNumbers(e)}
                              style={{
                                background: "grey",
                                border: "0.1 solid #ffffff",
                                borderRadius: "4px",
                                color: "#ffffff",
                                textAlign: "center",
                              }}
                              onChange={(e) =>
                                handleExecutionPriceChange(
                                  e.target.value,
                                  d.price,
                                  d?.itemId ? d?.itemId : null
                                )
                              }
                              className="inputBox"
                              value={d.executedPrice}
                            />
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td>Opportunity</td>
                        {tableData.map((d: any) => (
                          <td className="alignCenter">
                            ${numberFormatter(Number(d.opportunity), 2)}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "center" }}>Accept</td>
                        {tableData.map((d: any) => (
                          <>
                            <td style={{ marginLeft: "50%" }}>
                              {/* <i
                                style={{
                                  background:
                                    d?.isAgreed == 1 &&
                                      d?.copyAxecutedPrice == d.executedPrice
                                      ? "grey"
                                      : "green",
                                  fontSize: "0.8vw",
                                  cursor: "pointer",
                                  marginLeft: "48%",
                                  padding: "1%",
                                }}
                                // onClick={() => handleAcceptFromCustomerSelect(d, itemId, itemExecPrice === d.executedPrice ? false : true, recommendationAction.itemData ? true : false)}
                                onClick={() => d?.isAgreed == 1 ? handleRejectFromCustomerSelect({ itemId: index ? d.itemId : itemId, customerId: d.customer, division: selectedCustomerData?.division, }, 0, selectedCustomerData)
                                  :
                                  handleAcceptFromCustomerSelect(
                                    {
                                      itemId: index ? d.itemId : itemId,
                                      customerId: d.customer,
                                      division: selectedCustomerData?.division,
                                      executedPrice: d.executedPrice,
                                      peerPrice: d.peerPrice,
                                      opportunity: d.opportunity,
                                      isAgreed: d.isAgreed,
                                      copyAdjustedPrice: d.copyAxecutedPrice,
                                    },
                                    0,
                                    selectedCustomerData
                                  )
                                }
                                className="fa fa-check "
                                aria-hidden="true"
                              ></i> */}
                               <CheckBoxIcon
                                  sx={{ color: `${( d?.isAgreed == 1 &&
                                      d?.copyAxecutedPrice == d.executedPrice)?'gray':'green'}`, cursor:'pointer'}} 
                                  onClick={() => d?.isAgreed == 1 ? handleRejectFromCustomerSelect({ itemId: index ? d.itemId : itemId, customerId: d.customer, division: selectedCustomerData?.division, }, 0, selectedCustomerData)
                                    :
                                    handleAcceptFromCustomerSelect(
                                      {
                                        itemId: index ? d.itemId : itemId,
                                        customerId: d.customer,
                                        division: selectedCustomerData?.division,
                                        executedPrice: d.executedPrice,
                                        peerPrice: d.peerPrice,
                                        opportunity: d.opportunity,
                                        isAgreed: d.isAgreed,
                                        copyAdjustedPrice: d.copyAxecutedPrice,
                                      },
                                      0,
                                      selectedCustomerData
                                    )
                                  }
                                />
                              {/* <span>Click to accept Adjusted Price ($) </span> */}
                            </td>
                          </>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                  {/* <Row className="show-grid">
                                <Col md={18}></Col>
                                <Col md={3} >
                                    <div className={recommendationAction.itemData ? "submitCts" : "submitCtsDisabled"} style={{ paddingTop: "3px" }}>
                                        <Button onClick={handleSubmit}
                                            style={{ padding: "4% 19%", width: "100%" }}
                                            appearance="default">Submit</Button>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div style={{ paddingTop: "3px" }}>
                                        <Button onClick={() => { console.log('Implement Save') }}
                                            style={{
                                                padding: "4% 19%", width: "100%", color: 'white',
                                                background: '#26890d'
                                            }}
                                            appearance="default">Save</Button>
                                    </div>
                                </Col>
                            </Row> */}
                </>
              ) : (
                <span className="divTextCenter">
                  Click on the left Table to get the Detailed view
                </span>
              )}
          </Col>
        </Row>

        <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
          <Button
            onClick={() =>
              handleAcceptFromCustomerSelect(
                {
                  tableData
                },
                3,
                selectedCustomerData
              )
            }
            style={{
              padding: "2% 10%",
              margin: "7px 0px",
              color: "white",
              background: "#26890d",
            }}
            appearance="default"
          >
            Save
          </Button>
        </div>

      </>
    );
  }
}
